import React from 'react';
import core from '@gin-betting/core';
import cn from 'classnames';

import useDebugInfo from './useDebugInfo';

import './debugInfo.scss';

interface Props {
    text: string | undefined;
    isInlineBlock?: boolean;
    isRelativePosition?: boolean;
}

const {
    utils: { isDebugEnabled },
} = core;

const DebugInfo: React.FC<Props> = ({
    text,
    isInlineBlock,
    isRelativePosition,
}) => {
    const { isCopied, onClickHandler } = useDebugInfo({ text });

    if (!isDebugEnabled() || !text) return null;

    return (
        <div
            styleName={cn('container', {
                'is-inline-block': isInlineBlock,
                'is-relative': isRelativePosition,
            })}
        >
            <div
                onClick={onClickHandler}
                title="Copy to clipboard"
                styleName="text"
            >
                {text}
            </div>
            {isCopied && <div styleName="copied">Copied to clipboard!</div>}
        </div>
    );
};

export default DebugInfo;
